import hashFn from 'xxhashjs';

export function generateHash(str, hashLength = 8) {
  const hashBase = 0xabcd;

  return hashFn.h32(str, hashBase).toString(hashLength);
}

export const titleCase = (str) => {
  if (str) {
    return str
      .trim()
      .split(' ')
      .filter((w) => w !== '')
      .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(' ');
  }
  return '';
};
